import {preventDefault, stopPropagation} from 'ol/events/Event';

export {preventDefault, stopPropagation};
